"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissionsDef = void 0;
const joi_1 = __importDefault(require("joi"));
const general_1 = require("../general");
const roles_1 = require("../roles");
exports.permissionsDef = Object.assign(Object.assign({}, general_1.daoObjSchemaDef), { version: joi_1.default.number().required(), roles: joi_1.default.object({
        [roles_1.Roles.SUBMIT_EXAMS_OFFICER]: joi_1.default.array().items(joi_1.default.string()),
        [roles_1.Roles.SUBMIT_MODERATOR]: joi_1.default.array().items(joi_1.default.string()),
        [roles_1.Roles.SUBMIT_ADMINISTRATOR]: joi_1.default.array().items(joi_1.default.string()),
        [roles_1.Roles.SUBMIT_SUPER_ADMIN]: joi_1.default.array().items(joi_1.default.string()),
        [roles_1.Roles.SUBMIT_INTERNAL_ASSESSMENT_MANAGER]: joi_1.default.array().items(joi_1.default.string()),
        [roles_1.Roles.SUBMIT_COMPLIANCE]: joi_1.default.array().items(joi_1.default.string()),
        [roles_1.Roles.SUBMIT_TEACHER]: joi_1.default.array().items(joi_1.default.string()),
        [roles_1.Roles.SUBMIT_INTERNAL_MODERATOR]: joi_1.default.array().items(joi_1.default.string()),
        [roles_1.Roles.SUBMIT_HELPDESK]: joi_1.default.array().items(joi_1.default.string()),
        [roles_1.Roles.DELEGATED_ADMIN]: joi_1.default.array().items(joi_1.default.string()),
    }) });
